var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tippy',{attrs:{"to":_vm.to,"theme":_vm.darkMode ? 'dark' : 'light',"trigger":_vm.hoverable ? 'mouseenter' : 'click',"placement":_vm.placement,"arrow":"true","arrow-type":"round","animate-fill":"false","animation":"shift-away","interactive":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }